<fieldset style="padding-top: 20px;">
  <p i18n="@@filtro-disciplina">Filtrar por disciplinas:</p>
  <div style="display: flex; flex-direction: column; gap: 10px;">
    <div style="display: flex; gap: 20px;">
      <mat-slide-toggle color="success" (change)="this.filtrarAtiva($event)"></mat-slide-toggle>
      <mat-label i18n="@@filtro-ativa">oferecidas no ano letivo atual</mat-label>
    </div>
    <div style="display: flex; gap: 20px;">
      <mat-slide-toggle color="success" (change)="this.filtrarEmPortugues($event)"></mat-slide-toggle>
      <mat-label i18n="@@filtro-em-portugues">em português</mat-label>
    </div>
    <div style="display: flex; gap: 20px;">
      <mat-slide-toggle color="success" (change)="this.filtrarEmOutrosIdiomas($event)"></mat-slide-toggle>
      <mat-label i18n="@@filtro-em-outros-idiomas">em outros idiomas</mat-label>
    </div>
    <div style="display: flex; gap: 20px;">
      <mat-slide-toggle color="success" (change)="this.filtrarPortfolio($event)"></mat-slide-toggle>
      <mat-label i18n="@@filtro-portfolio">do Portfólio de Integração de Disciplinas da Pós-graduação</mat-label>
    </div>
  </div>
</fieldset>
<table mat-table [dataSource]="disciplinas" class="mat-elevation-z8" style="margin-top: 20px;">
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef i18n="@@nome">Nome</th>
    <td mat-cell *matCellDef="let disciplina" data-label="Nome" i18n-data-label="@@nome">{{ disciplina.nome }}</td>
  </ng-container>
  <ng-container matColumnDef="nivel">
    <th mat-header-cell *matHeaderCellDef i18n="@@nivel">Nível</th>
    <td mat-cell *matCellDef="let disciplina" data-label="Nível" i18n-data-label="@@nivel">{{ disciplina.nivel }}</td>
  </ng-container>
  <ng-container matColumnDef="idioma">
    <th mat-header-cell *matHeaderCellDef i18n="@@idioma">Idioma</th>
    <td mat-cell *matCellDef="let disciplina" data-label="Idioma" i18n-data-label="@@idioma">{{ disciplina.idioma }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="disciplinaColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: disciplinaColumns;"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="3" i18n="@@nenhum_resultado" style="padding: 10px;">Nenhum resultado encontrado para a pesquisa.</td>
  </tr>
</table>